import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { dateParser } from "../components/Utils";
import { toast } from "react-toastify";
import Modal from "react-modal";
import CarteAnnonces from "../components/Annonce/CarteAnnonces";
import StatistiquesAdmin from "./StatsAdmin";
import ListeUtilisateursAdmin from "./AdminListeUtilisateur";

const AdminDashboard = () => {
  const [annonces, setAnnonces] = useState([]);

  const [showUsers, setShowUsers] = useState(false);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedAnnonce, setSelectedAnnonce] = useState(null);
  const [searchPhone, setSearchPhone] = useState("");

  const fetchAnnonces = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/admin/annonces/non-publiees`,
        { withCredentials: true }
      );
      setAnnonces(res.data);
    } catch (err) {
      console.error("Erreur fetch annonces", err);
    }
  };

  useEffect(() => {
    fetchAnnonces();
  }, []);

  const validerAnnonce = async (id) => {
    if (!window.confirm("Êtes-vous sûr de vouloir valider cette annonce ?"))
      return;
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/admin/annonces/${id}/valider`,
        {},
        { withCredentials: true }
      );
      fetchAnnonces();
      toast.success("Annonce validée et publiée avec succès !");
    } catch (err) {
      console.error("Erreur validation", err);
    }
  };

  const refuserAnnonce = async (id) => {
    if (!window.confirm("Êtes-vous sûr de vouloir refuser cette annonce ?"))
      return;
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/admin/annonces/${id}/refuser`,
        { withCredentials: true }
      );
      fetchAnnonces();
      toast.info("Annonce refusée et supprimée");
    } catch (err) {
      console.error("Erreur refus", err);
    }
  };

  return (
    <>
      <Header />
      <div>
        <header>
          <h2>Statistiques</h2>
          <div className="stats">
            <StatistiquesAdmin />
          </div>
          <button className="usersListe" onClick={() => setShowUsers(!showUsers)}>
            {showUsers
              ? "Masquer les utilisateurs"
              : "Voir tous les utilisateurs"}
          </button>

          {showUsers && <ListeUtilisateursAdmin />}
        </header>
        <section>
          <h2>Annonces non publiées</h2>
          <div style={{ marginBottom: "1rem", marginLeft: "1rem" }}>
            <input
              type="text"
              placeholder="Rechercher par téléphone"
              value={searchPhone}
              onChange={(e) => setSearchPhone(e.target.value)}
              style={{ padding: "8px", borderRadius: "4px", width: "250px" }}
            />
          </div>
          <table>
            <thead>
              <tr>
                <th>Date création</th>
                <th>Utilisateur</th>
                <th>Téléphone</th>
                <th>Annonce à publier</th>
                <th>Catégorie</th>
                <th>Détail</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {annonces.length === 0 && (
                <tr>
                  <td colSpan="3">Aucune annonce en attente</td>
                </tr>
              )}
              {annonces
                .filter((annonce) =>
                  annonce.utilisateur?.phone
                    ?.toLowerCase()
                    .includes(searchPhone.toLowerCase())
                )
                .map((annonce) => (
                  <tr key={annonce._id}>
                    <td>{dateParser(annonce.datePublication)}</td>
                    <td>
                      {annonce.utilisateur?.lastname || "Inconnu"}{" "}
                      {annonce.utilisateur?.firstname || "Inconnu"}
                    </td>
                    <td>{annonce.utilisateur?.phone}</td>
                    <td>{annonce.titre}</td>
                    <td>{annonce.categorie}</td>
                    <td
                      onClick={() => {
                        setSelectedAnnonce(annonce);
                        setModalIsOpen(true);
                      }}
                    >
                      Détail
                    </td>
                    <td>
                      <button onClick={() => validerAnnonce(annonce._id)}>
                        Accepter
                      </button>
                      <button onClick={() => refuserAnnonce(annonce._id)}>
                        Refuser
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </section>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setModalIsOpen(false)}
          style={customStyles}
        >
          <button onClick={() => setModalIsOpen(false)}>Fermer</button>
          {selectedAnnonce && (
            <CarteAnnonces
              key={selectedAnnonce._id}
              annonce={selectedAnnonce}
              utilisateurId={selectedAnnonce.utilisateur?._id}
            />
          )}
        </Modal>

        <Footer />
      </div>
    </>
  );
};

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "2rem",
    borderRadius: "10px",
  },
};

export default AdminDashboard;
